import { combineReducers } from "redux";

import figuritasReducer from "./figuritasReducer";
import currentUserReducer from "./currentUserReducer";
//combino los states de los reducers en 1 solo para poder accederlo desde los componentes
export default combineReducers({
  figuritasReducer: figuritasReducer,
  currentUser: currentUserReducer,
});
